import React, {PureComponent} from 'react';
import AlertsTemplate from '../../templates/PageLayout/Alerts.rt';

class alerts extends PureComponent {
  render = AlertsTemplate
}

const Alerts = alerts;

export default Alerts;
